import * as Yup from "yup";

const SecurityInfoValidation = Yup.object().shape({
  patientInfo: Yup.object().shape({
    securityInfo: Yup.object()
      .shape({
        mrn: Yup.string().matches(/^[a-zA-Z0-9]+$/, "MRN must be alphanumeric"),
        ssn: Yup.string()
          .max(11)
          .matches(
            /\d{3}-\d{2}-\d{4}/,
            "SSN must contain 9 digits with following format 000-00-0000"
          ),
      })
      .when(["testTypeId"], {
        is: (testTypeId: number) => {
          return testTypeId === 4 || testTypeId === 7;
        },
        then: (schema) =>
          schema.shape({
            ssn: Yup.string()
              .max(11)
              .matches(
                /\d{3}-\d{2}-\d{4}/,
                "SSN must contain 9 digits with following format 000-00-0000"
              )
              .when(["mrn"], {
                is: (mrn: string) => {
                  let regex = new RegExp(/^[a-zA-Z0-9]+$/);
                  return !mrn || mrn.length === 0 || !regex.test(mrn);
                },
                then: (schema) =>
                  schema
                    .required("SSN is required!")
                    .max(11)
                    .matches(
                      /\d{3}-\d{2}-\d{4}/,
                      "SSN must contain 9 digits with following format 000-00-0000"
                    ),
              }),
            mrn: Yup.string().matches(
              /^[a-zA-Z0-9]+$/,
              "MRN must be alphanumeric"
            ),
          }),
      }),
  }),
});

export default SecurityInfoValidation;
